import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ContentSection } from './components/ContentSection';
import { BonusSection } from './components/BonusSection';
import { BenefitsSection } from './components/BenefitsSection';
import { UrgencySection } from './components/UrgencySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CtaFinalSection } from './components/CtaFinalSection';
import { FaqSection } from './components/FaqSection';
import { Footer } from './components/Footer';
import { ParticlesBackground } from './components/ParticlesBackground';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="min-h-screen bg-spaceBg text-white font-sans scroll-smooth relative" data-id="element-0">
      {/* Global Space/Galaxy Background */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden bg-spaceBg" data-id="element-1">
        {/* Floating Particles */}
        <ParticlesBackground data-id="element-2" />

        {/* Nebula Glows */}
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-gradPurple/20 blur-[120px] rounded-full mix-blend-screen" data-id="element-3" />
        <div className="absolute top-[20%] right-[-5%] w-[30%] h-[50%] bg-gradPink/15 blur-[150px] rounded-full mix-blend-screen" data-id="element-4" />
        <div className="absolute bottom-[-10%] left-[20%] w-[50%] h-[40%] bg-gradOrange/10 blur-[130px] rounded-full mix-blend-screen" data-id="element-5" />
        <div className="absolute bottom-[10%] right-[10%] w-[25%] h-[30%] bg-gradPurple/20 blur-[100px] rounded-full mix-blend-screen" data-id="element-6" />
      </div>

      {/* Meta Pixel tracking image */}
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1934048370513297&ev=PageView&noscript=1" alt="" data-id="element-7" />

      <div className="relative z-10" data-id="element-8">
        <Header data-id="element-9" />

        <main data-id="element-10">
          <HeroSection data-id="element-11" />
          <ContentSection data-id="element-12" />
          <BonusSection data-id="element-13" />
          <BenefitsSection data-id="element-14" />
          <UrgencySection data-id="element-15" />
          <TestimonialsSection data-id="element-16" />
          <CtaFinalSection data-id="element-17" />
          <FaqSection data-id="element-18" />
        </main>

        <Footer data-id="element-19" />
      </div>

      {/* Social proof purchase notifications */}
      <PurchaseNotifications data-id="element-20" />
    </div>;
}